export const user_sample = {
  message: {
    demography: {
      preferred_resource_type: "Podcasts,Videos,Books",
      limit: 20,
      not_employed: "",
      religious: "Neither",
      specify_religion: "",
      employed: "In-Office",
      military_status: "None",
      marital_status: "Divorced",
      parental_status: "Non-Parent",
      race: "Hispanic or Latino",
      age_of_children: "",
      children_info: "",
      age: "34",
      gender: "M",
      activity_level: "",
      yearly_household_income: "50000",
      sexual_orientation: "",
      Name: "Robert",
    },
    last_clinical_intake: [
      {
        Question: "Emergency Contact Name",
        Answer: "John Smith",
      },
      {
        Question: "Emergency Contact Phone Number",
        Answer: "(999) 999-9999",
      },
      {
        Question: "Are you having thoughts of self-harm or suicidal ideation?",
        Answer: "No",
      },
      {
        Question:
          "Do you have any history of suicidal thoughts or suicide attempts? ",
        Answer: "No",
      },
      {
        Question: "When was the last time?",
        Answer: "",
      },
      {
        Question: "Do you have thoughts or urges to harm others? ",
        Answer: "No",
      },
      {
        Question: "What is your marital status? ",
        Answer: "Divorced",
      },
      {
        Question: "How many children do you have?",
        Answer: "0",
      },
      {
        Question:
          "What is your level of education? (Highest grade/degree and type of degree)",
        Answer: "High School",
      },
      {
        Question: "Ethnicity?",
        Answer: "Hispanic",
      },
      {
        Question: "What is your current place of employment? ",
        Answer: "ABC Company",
      },
      {
        Question: "What is your job title?",
        Answer: "Marketing Manager",
      },
      {
        Question: "How long have you been in this current role?",
        Answer: "1 Year",
      },
      {
        Question: "What is your work setting?",
        Answer: "In-Person",
      },
      {
        Question: "Rate your job satisfaction.",
        Answer: "4",
      },
      {
        Question:
          "Can we follow up with you by email to get feedback about your experience with our services?",
        Answer: "Yes",
      },
      {
        Question: "Were you referred for a work performance problem? ",
        Answer: "No",
      },
      {
        Question: "Have you ever been to counseling or therapy before?  ",
        Answer: "Yes",
      },
      {
        Question:
          "If yes, when was the last time you were actively participating in counseling? ",
        Answer: "2019",
      },
      {
        Question: "What was the name of your previous counselor?",
        Answer: "Michael",
      },
      {
        Question: "Reason for previous counseling?",
        Answer: "Relationship Issues",
      },
      {
        Question: "What is the reason you are seeking services at this time?",
        Answer: "Just to get back into a clear head space",
      },
      {
        Question:
          "What goal(s) are you looking to accomplish with your counselor/coach?",
        Answer:
          "To receive tools and resources to overcome trauma and on-going self-sabbotage.",
      },
      {
        Question:
          "Specify all prescribed medications and supplements you are presently taking and for what reason.",
        Answer: "N/A",
      },
      {
        Question:
          "Are you using any medications not prescribed to you or in greater amounts than prescribed, or using any other substances?",
        Answer: "No",
      },
      {
        Question: "What substances are you using and how often?",
        Answer: "",
      },
      {
        Question: "Physical / Medical",
        Answer:
          "[9.Sex concerns (difficulty having sex, sexual desire, STIs). ]",
      },
      {
        Question: "Emotional / Mental",
        Answer:
          "[1.Feeling down, depressed, lonely, hopeless, and/or little pleasure in doing things. ], [3.Feeling anxious, nervous, worried, and/or fearful.]",
      },
      {
        Question: "Social / Relationships",
        Answer: "[1.Relationship and/or marital discord. ]",
      },
      {
        Question: "Occupational / Intellectual",
        Answer: "",
      },
      {
        Question: "Financial / Legal",
        Answer:
          "[2.\tBudgeting, debt, and/or credit concerns. ], [6.\tProblems saving money.]",
      },
      {
        Question: "Spiritual / Environmental",
        Answer: "",
      },
    ],
    appointment_history: [
      {
        LOC: "Individual - Video",
        reason_for_call:
          "Recently went through a divorce after a year and a half long separation where the relationship was toxic and abusive. As I'm moving forward in life, I'm looking for tools to succeed as I'm entering a new relationship with someone who has trauma and bit of an over-thinker, leaving me feeling anxious and thinking one day they'll get up and leave.",
        clinical_notes:
          "\u003Cp\u003ESession 1: 5/13/24\u003C/p\u003E\u003Cp\u003EPronouns: he/him\u003C/p\u003E\u003Cp\u003E\u003Cstrong\u003E\u003Cem\u003EVERBAL ACKNOWLEDGEMENT FOR TRANSCRIPTIONS\u003C/em\u003E\u003C/strong\u003E\u003C/p\u003E\u003Cp\u003EDirect Pay -- talk about that\u003C/p\u003E\u003Cp\u003EGoal:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EHow to manage ending relationship w/ct's ex + starting new relationship w/new partner.\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003ECurrent Reality:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003ERecently got divorced. New chapter in life.\u003C/li\u003E\u003Cli\u003EHow to figure out how to move past that stage.\u003C/li\u003E\u003Cli\u003ECt reported being over the relationship &amp; fact that it didn't work out. Good as friends &amp; not as partners.\u003C/li\u003E\u003Cli\u003EHusband separated. Mental and verbal abuse. Had to be ex's way, ct felt inferior.\u003C/li\u003E\u003Cli\u003EEmotional abuse, gaslighting, manipulation.\u003C/li\u003E\u003Cli\u003EEx-husband was going through therapy now. He's apologizing now.\u003C/li\u003E\u003Cli\u003EMoving into new relationship w/new person who has \"trauma &amp; baggage\"\u003C/li\u003E\u003Cli\u003EFive yr relationship.\u003C/li\u003E\u003Cli\u003ECt never reaches out to ex. Ex reaches out to ct, to talk about closure. Been separated for awhile, divorce just finalized.\u003C/li\u003E\u003Cli\u003EIs ct still emotionally attached to ex? Not a lot. Doesn't call or text. No social media.\u003C/li\u003E\u003Cli\u003ECt feels like closure he needed, doesn't need communication.\u003C/li\u003E\u003Cli\u003EBoundary set this weekend? I'm not wiling to put this relationship w/ex over ct's future.\u003C/li\u003E\u003Cli\u003EWhat does ct need to move forward? Told his ex that \"this needs to stop\". No contact w/ex. Ct doesn't feel the need to have contact.\u003C/li\u003E\u003Cli\u003ECurrent partner, Hector, doesn't want ct to have any contact at all.\u003C/li\u003E\u003Cli\u003ECt hx people pleaser\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003EOptions/Way Forward:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EBest outcome? Ex will respect the boundary &amp; decision that ct has made. \"Do not reach out to me unless it's a dire emergency.\"\u003C/li\u003E\u003C/ul\u003E",
      },
      {
        LOC: "Individual - Video",
        reason_for_call:
          "Recently went through a divorce after a year and a half long separation where the relationship was toxic and abusive. As I'm moving forward in life, I'm looking for tools to succeed as I'm entering a new relationship with someone who has trauma and bit of an over-thinker, leaving me feeling anxious and thinking one day they'll get up and leave.",
        clinical_notes:
          "\u003Cp\u003ESession 2: 5/28/24\u003C/p\u003E\u003Cp\u003EGoal:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003ENavigating new relationship w/someone different than ct is (more vocal, etc)\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003ECurrent Reality:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003ECovo wasn't hard for him, hard for ex.\u003C/li\u003E\u003Cli\u003EEx has abandonment issues. Feels abandoned by ct's boundary.\u003C/li\u003E\u003Cli\u003ECt clarified, boundary not abandonment. Felt good about setting firm boundary. Feels indifferent, not sad/happy.\u003C/li\u003E\u003Cli\u003ECt's partner is feeling better about it.\u003C/li\u003E\u003Cli\u003ECurrent partner can't talk himself down from things.\u003C/li\u003E\u003Cli\u003EStubbornness &amp; pride gets in the way for partner.\u003C/li\u003E\u003Cli\u003EPartner: what do you need from me? Ct asks partner. Partner usually asks for space &amp; alone time.\u003C/li\u003E\u003Cli\u003EWhat partner needed to regulate caused anxiety in client.\u003C/li\u003E\u003Cli\u003EFeels talking about things, loves being open and communicating his feelings.\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003EOptions/Way Forward:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003ETakeaway: Having to be ok, still processing/learning, not having all info when someone is mad is ok, be patient that he will open up in time &amp; he will let ct in.\u003C/li\u003E\u003Cli\u003ECt needs reassurance. May need to clarify for new partner what that means or looks like/make requests.\u003C/li\u003E\u003Cli\u003EUnderstanding how partner is: This just me, I need my time alone. I've always been the person to take care of things by myself. Allow me to speak when I'm ready\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003E\u003Cstrong\u003E\u003Cu\u003ENEXT (LAST) SESSION: Talk w/client about Direct Pay program &amp; what to do to get signed up!\u003C/u\u003E\u003C/strong\u003E\u003C/p\u003E",
      },
      {
        LOC: "Individual - Video",
        reason_for_call:
          "Recently went through a divorce after a year and a half long separation where the relationship was toxic and abusive. As I'm moving forward in life, I'm looking for tools to succeed as I'm entering a new relationship with someone who has trauma and bit of an over-thinker, leaving me feeling anxious and thinking one day they'll get up and leave.",
        clinical_notes:
          "\u003Cp\u003ESession 3: 6/11/24\u003C/p\u003E\u003Cp\u003EGoal:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EClosure session\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003ECurrent Reality:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EAnxiety from yesterday.\u003C/li\u003E\u003Cli\u003ECall from ex, came up as “My King” in Spanish.\u003C/li\u003E\u003Cli\u003EHuge argument w/current partner.\u003C/li\u003E\u003Cli\u003EPartner accusing ct of having people over.\u003C/li\u003E\u003Cli\u003EPartner apologized, extremely hurt.\u003C/li\u003E\u003Cli\u003ENot about client, not about ct's character.\u003C/li\u003E\u003Cli\u003EAfraid of their past.\u003C/li\u003E\u003Cli\u003ELingering hurt from accusations from current partner.\u003C/li\u003E\u003Cli\u003EApologized again, twice.\u003C/li\u003E\u003C/ul\u003E\u003Cp\u003EOptions/Way Forward:\u003C/p\u003E\u003Cul\u003E\u003Cli\u003EOption 1: Ending relationship completely.\u003C/li\u003E\u003Cli\u003EOption 2: Being mindful of partner's trauma &amp; past. Try not to take it too personal if something comes up. Doesn't want to carry a burden that's not clients\u003C/li\u003E\u003Cli\u003EOptions 3: Asking partner, how are we going to know that this won't happen again?\u003C/li\u003E\u003Cli\u003ESend ct's YouTube: 2 videos anxious/fight/flight\u003C/li\u003E\u003C/ul\u003E",
      },
    ],
    message_history: [],
  },
};

export const orderedKeys = [
  "Name",
  "age",
  "gender",
  "marital_status",
  "yearly_household_income",
  "employed",
  "not_employed",
  "activity_level",
  "age_of_children",
  "children_info",
  "parental_status",
  "race",
  "religious",
  "specify_religion",
  "sexual_orientation",
  "military_status",
  "preferred_resource_type",
];
